import React from 'react';

import { Box, BoxContainer, BoxHeader, BoxMessage } from 'src/components/atoms/Box/Box';

export const AlreadyApplied = () => {
  return (
    <BoxContainer>
      <Box>
        <BoxHeader>You&apos;ve already applied with us using this account</BoxHeader>
        <BoxMessage>
          If you want to apply again please sign out and create a new account to submit a fresh
          application
        </BoxMessage>
      </Box>
    </BoxContainer>
  );
};
